import type { FailCodeLocationItem } from '@packages/clients';

import type { FailCodeLocationEntity } from '../entities';

/**
 * Map a fail code location DTO to a {@link FailCodeLocationEntity}. Renames the `specific` field
 * to `isSpecific` to follow the boolean naming convention.
 *
 * @param dto - the {@link FailCodeLocationItem} from the API
 * @returns the domain entity
 * @example
 * ```ts
 * const entity = toFailCodeLocationEntity({ code: '01', description: 'Engine', specific: true });
 * // { code: '01', description: 'Engine', isSpecific: true }
 * ```
 */
export function toFailCodeLocationEntity(dto: FailCodeLocationItem): FailCodeLocationEntity {
    return {
        code: dto.code,
        description: dto.description,
        isSpecific: dto.specific,
    };
}
